export const UPWARDS = 'up'
export const DOWNWARDS = 'down'

export const UNPINNED = 'unpinned'
export const PINNED = 'pinned'
export const STATIC = 'static'

export const NO_TRANSITION = 'none'
export const NORMAL_TRANSITION = 'normal'
export const PINNED_TO_STATIC = 'pinned-to-static'
